import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { isEmpty } from 'lodash';
import apiSaga from './apiSaga';
import {
  START_OR_RESUME_SURVEY,
  COMMIT_QUESTION_BLOCK,
  GET_BLOCK,
} from 'actionTypes';
import {
  startOrResumeSurveySuccess,
  startOrResumeSurveyFailure,
  commitQuestionBlockSuccess,
  commitQuestionBlockFailure,
  completeSurvey,
  getBlockSuccess,
} from 'actions';

import { blockSelector } from 'selectors';

function questionBlockSagaTemplate(successCreator, failureCreator = null) {
  return function*(action) {
    let response = yield call(apiSaga, action, action.payload);
    if (isEmpty(response.payload)) {
      yield put(completeSurvey());
    } else if (isEmpty(response.errors)) {
      yield put(successCreator(response));
    } else if (failureCreator !== null) {
      yield put(failureCreator(response));
    }
  };
}

const startOrResumeSurveySaga = questionBlockSagaTemplate(
  startOrResumeSurveySuccess,
  startOrResumeSurveyFailure
);

const commitQuestionBlockSaga = questionBlockSagaTemplate(
  commitQuestionBlockSuccess,
  commitQuestionBlockFailure
);

function* getQuestionBlockSaga(action) {
  const block = yield select(blockSelector, action.endpointArgs.blockId);
  let response;
  if (block) {
    response = { payload: block, errors: [] };
  } else {
    response = yield call(apiSaga, action);
  }
  if (isEmpty(response.errors)) {
    yield put(getBlockSuccess(response));
  }
}

export default [
  takeEvery(START_OR_RESUME_SURVEY, startOrResumeSurveySaga),
  takeEvery(COMMIT_QUESTION_BLOCK, commitQuestionBlockSaga),
  takeLatest(GET_BLOCK, getQuestionBlockSaga),
];



// WEBPACK FOOTER //
// ./src/sagas/questionBlockSagas.js